export default __webpack_public_path__ + "static/media/Untitled design (21).34e94fc6.png";